export const RPHeaderElements = [
  { label: "Aplica a", value: "aplicaA", align: "inherit" },
  { label: "Nombre", value: "nombre", align: "inherit" },
  { label: "Clase", value: "clase", align: "inherit" },
  { label: "Valor", value: "valor", align: "inherit" },
  { label: "Estado", value: "activo", align: "inherit" },
];
